import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function IntegrationsButton({ handler, status }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="float-right">
      {status ? (
        <Button onClick={handler} size="md" className="text-danger btn-link edit" title={t("common.actions.deactivateIntegration")}>
          <i className="nc-icon nc-button-pause icon-bold" />
        </Button>
      ) : (
        <Button onClick={handler} size="md" className="text-success btn-link edit" title={t("common.actions.activateIntegration")}>
          <i className="nc-icon nc-button-play icon-bold" />
        </Button>
      )}
    </div>
  );
}
